import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mainWrapper" }

import { computed, watch, onMounted } from 'vue';
import { useTheme } from 'vuetify';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const theme = useTheme();
const store = useStore();
const { locale } = useI18n();

const isRtl = computed(() => store.state.lang.lang === 'ar');

onMounted(() => {
  theme.change('light');
});

watch(isRtl, (newIsRtl) => {
  document.documentElement.setAttribute('dir', newIsRtl ? 'rtl' : 'ltr');
}, { immediate: true });

watch(() => store.state.lang.lang, (newLang) => {
  locale.value = newLang;
  document.documentElement.setAttribute('lang', newLang);
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!

  return (_openBlock(), _createBlock(_component_v_locale_provider, { rtl: isRtl.value }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["rtl"]))
}
}

})